export * from "ce/constants/UsagePulse";
export const PULSE_INTERVAL = 300000; /* 5 minutes in miliseconds */
